































































































































import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class MenuMdAndUp extends Vue {
  goToHome() {
    // avoid redundant navigation to current route
    if (this.$route.name !== "Home") {
      this.$router.push("/home");
    }
  }

  goToContactUs() {
    this.$router.push("/contact-us");
  }
}
